import 'slick-carousel-latest';

(function($){

    const CCISliderSlick = {

        init: () => {       

            $('.single-project-slider').slick({
                dots: true,
                prevArrow: false,
                nextArrow: false,
                infinite: true,
                speed: 2500,
                slidesToShow: 1,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnHover: true,
                fade: true
            });

            $('.related-projects').slick({
                dots: true,
                prevArrow: false,
                nextArrow: false,
                infinite: true,
                speed: 2500,
                slidesToShow: 4,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnHover: true,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 3
                        }
                    }
                ]
            });

            $('.testimonials').slick({
                dots: true,
                prevArrow: false,
                nextArrow: false,
                infinite: true,
                speed: 2500,
                slidesToShow: 1,
                adaptiveHeight: true,
                autoplay: true,
                autoplaySpeed: 5000,
                pauseOnHover: true
            });

        }

    }

    $(function(){

        CCISliderSlick.init();

    });

})(jQuery);